var exports = {
  "Ru": "CreateDialog__Gb5GDy",
  "Dr": "CreateDialogHasBanner__YB1EkM",
  "lV": "Form__zzFOBb",
};

module.exports = exports;
